import { render, staticRenderFns } from "./Saved.vue?vue&type=template&id=394cecc2&scoped=true"
import script from "./Saved.vue?vue&type=script&lang=js"
export * from "./Saved.vue?vue&type=script&lang=js"
import style0 from "./Saved.vue?vue&type=style&index=0&id=394cecc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394cecc2",
  null
  
)

export default component.exports